import { z } from "zod";
export const MigrationRehearsalGuardV1Schema = z
    .object({
    schemaVersion: z.literal("migration-rehearsal-guard.v1.0"),
    migrationName: z.string().min(1),
    forwardApplied: z.boolean(),
    backwardStrategy: z.enum(["RESTORE_BACKUP", "FORWARD_FIX_ONLY"]),
    backupTaken: z.boolean(),
    rehearsalEnvironment: z.enum(["STAGING", "LOCAL"]),
    recordedAt: z.string().datetime(),
})
    .strict();
export function assertMigrationRehearsalGuard(record) {
    const parsed = MigrationRehearsalGuardV1Schema.parse(record);
    if (!parsed.forwardApplied)
        throw new Error("migration_forward_not_applied");
    if (!parsed.backupTaken && parsed.backwardStrategy === "RESTORE_BACKUP") {
        throw new Error("migration_backup_required");
    }
}
//# sourceMappingURL=migration-rehearsal-guard.js.map